import { Box, makeStyles } from '@material-ui/core';
import { LinkProps, useParams } from '@reach/router';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga';

import PageContent from '../../../../../components/Layout/PageContent';
import { LinkState } from '../../../../RootPage';
import { useCompaniesDispatch } from '../../../shared/CompanyContext/CompanyContext';
import { CompanyContextActionTypes } from '../../../shared/CompanyContext/CompanyContext.types';
import OwnershipConnectionsBox from './OwnershipConnectionsBox/OwnershipConnectionsBox';
import { OwnershipConnectionsContextProvider } from './OwnershipConnectionsContext/OwnershipConnectionsContext';

interface Props {
  path: string;
  location: LinkProps<LinkState>;
}

const OwnershipConnectionsPage: React.FC<Props> = ({ location }) => {
  const classes = useStyles();
  ReactGA.pageview(window.location.pathname);
  const { dataset: datasetParam, dbVersion: dbVersionParam } = useParams<{
    dataset?: string;
    dbVersion?: string;
  }>();
  const companiesDispatch = useCompaniesDispatch();

  useEffect(() => {
    if (datasetParam || dbVersionParam) {
      companiesDispatch({
        type: CompanyContextActionTypes.SetDatasetInfo,
        payload: { dataset: datasetParam, dbVersion: dbVersionParam },
      });
    }
  }, [datasetParam, dbVersionParam, companiesDispatch]);

  return (
    <PageContent isPageHeightAuto={false}>
      <Box className={classes.connectionsWrapper}>
        <OwnershipConnectionsContextProvider>
          <OwnershipConnectionsBox companyDetailsPath={location.state?.companyDetailsPath || ''} />
        </OwnershipConnectionsContextProvider>
      </Box>
    </PageContent>
  );
};

const useStyles = makeStyles(() => ({
  connectionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flexGrow: 1,
  },
}));

export default OwnershipConnectionsPage;
